export default __webpack_public_path__ + "static/media/binblack.8ad614f3.svg";